import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import type {
	PutWidgetInteractionRequestBody,
	PutWidgetInteractionRequestParams,
	PutWidgetInteractionResponse,
} from './types';

export const putWidgetInteraction = async (
	{
		widgetId,
		isApp = false,
		interactionsBaseUrl,
	}: PutWidgetInteractionRequestParams,
	body: PutWidgetInteractionRequestBody
): Promise<AxiosResponse<PutWidgetInteractionResponse>> => {
	const url = interactionsBaseUrl
		? `${interactionsBaseUrl}/${widgetId}`
		: `/cityzens/interactions/${widgetId}`;

	return api.put<PutWidgetInteractionResponse>(url, body, {
		params: {
			isApp: Boolean(isApp),
		},
	});
};
